import DateField from 'components/DateField';

import Loading from 'components/Loading';
import RadioGroup from 'components/RadioGroup';
import { Map } from 'immutable';
import { keys } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { moment } from 'utils';

const dateFormat = 'DD.MM.YYYY';

export default class SlotSelect extends Component {
  static propTypes = {
    onSelectSlot: PropTypes.func.isRequired,
    selectedDate: PropTypes.object,
    selectedSlot: PropTypes.object,
    onSelectDate: PropTypes.func.isRequired,
    getSlots: PropTypes.func.isRequired,
    slots: PropTypes.instanceOf(Map).isRequired,
    taxAuthorityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    serviceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  };

  componentDidMount() {
    const { taxAuthorityId, serviceId, getSlots } = this.props;
    getSlots(taxAuthorityId, serviceId);
  }
  componentDidUpdate(prevProps) {
    const { serviceId, taxAuthorityId, getSlots } = this.props;
    if (
      prevProps.serviceId !== this.props.serviceId ||
      prevProps.taxAuthorityId !== this.props.taxAuthorityId
    ) {
      getSlots(taxAuthorityId, serviceId);
    }
  }

  onSelectSlot = (value, currentDay) => {
    const data = this.getData();
    const daySlots = data[moment(currentDay).format(dateFormat)];
    const slot = daySlots.find((slot) => slot.visitTime === value);
    this.props.onSelectSlot(slot);
  };

  getData = () => {
    const { slots } = this.props;
    return slots.get('data');
  };

  getDays = () => {
    const data = this.getData();

    return keys(data).map((day) => moment(day, dateFormat).toDate());
  };

  hasData = () => {
    const { slots } = this.props;
    const data = slots.get('data');

    return !!data;
  };

  isLoading = () => {
    const { slots } = this.props;
    return slots.get('loading');
  };

  renderTimeSlots = (currentDay) => {
    const { selectedSlot } = this.props;
    const data = this.getData();

    const daySlots = data[moment(currentDay).format(dateFormat)];
    const items = daySlots.map((slot) => {
      return {
        label: moment.parseZone(slot.visitTimeObject).format('HH:mm'),
        value: slot.visitTime,
      };
    });

    return (
      <div>
        <div className="form_label">Выберите время *</div>
        <RadioGroup
          items={items}
          selectedValue={selectedSlot ? selectedSlot.visitTime : null}
          onChange={(value) => this.onSelectSlot(value, currentDay)}
          isInline={true}
        />
      </div>
    );
  };
  renderSlots = () => {
    const availableDays = this.getDays();
    const { selectedDate, onSelectDate } = this.props;
    const currentDay = selectedDate || availableDays[0];
    if (!this.hasData() || !availableDays.length) {
      return null;
    }

    return (
      <div className="calendar calendar__inline">
        <DateField
          inline={true}
          startDateValue={currentDay}
          handleChangeStart={onSelectDate}
          label="Выберите дату *"
          showMonthDropdown={false}
          showYearDropdown={false}
          peekNextMonth={false}
          forceShowMonthNavigation={true}
          includeDates={availableDays}
        />
        {currentDay ? this.renderTimeSlots(currentDay) : null}
      </div>
    );
  };

  renderLoading = () => {
    return (
      <div className="loading-container loading-container__big">
        <Loading />
      </div>
    );
  };

  render() {
    return this.isLoading() ? this.renderLoading() : this.renderSlots();
  }
}
